import { render, staticRenderFns } from "./PlanUnitCard.vue?vue&type=template&id=34b89c1f&"
import script from "./PlanUnitCard.vue?vue&type=script&lang=js&"
export * from "./PlanUnitCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports